document.addEventListener('teeinblue-event-component-injected', function() {
  // const elementToMove = document.querySelector('.product-meta__taxes-included.text--small');
  // const targetElement = document.querySelector('.tee-block.tee-product-price');
  // if (elementToMove && targetElement) {        
  //   targetElement.appendChild(elementToMove); 
  // } 
  moveElementAfter('.tee-block.tee-product-price', '.product-meta__title')
});


const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};